import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10fe2c25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "weeks" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("h2", null, "How Many Weeks"),
  /*#__PURE__*/_createElementVNode("p", { style: {"width":"80vw","text-align":"center"} }, " In this project, I wanted to illustrate the extend of a human lifetime vissually. It is hosted on a different domain and rendered here for simplicity. For more details, see the description below. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://how-many-weeks.com",
  width: "90%",
  height: "800",
  style: {"border":"none"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { ref, computed } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "HowManyWeek",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}
}

})